(function($) {
    'use strict';
    
    $(document).ready(function() {
        // Quando un offcanvas viene aperto, chiudi gli altri
        $('#navbarNavOffcanvasMain').on('show.bs.offcanvas', function () {
            $('.offcanvas.show').not(this).each(function() {
                var otherOffcanvas = bootstrap.Offcanvas.getInstance(this);
                if(otherOffcanvas) {
                    otherOffcanvas.hide();
                }
            });
        });
        
        // Forza la chiusura del bottone se non funziona
        $('#navbarNavOffcanvasMain .btn-close').on('click', function() {
            var offcanvasEl = document.getElementById('navbarNavOffcanvasMain');
            var offcanvas = bootstrap.Offcanvas.getInstance(offcanvasEl);
            if(offcanvas) {
                offcanvas.hide();
            }
        });

       
        if (jQuery('.swiper-breaking').length) {

    var isMobile = window.innerWidth < 768;

    var swiperBannerConfig = {
        grabCursor: true,
        loop: true,
        autoplay: {
            delay: isMobile ? 3000 : 7000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: '#_banner_top .swiper-button-next',
            prevEl: '#_banner_top .swiper-button-prev',
        }
    };

    if (isMobile) {
        // Modalità carosello su mobile
        swiperBannerConfig.effect        = 'slide';
        swiperBannerConfig.slidesPerView = 1.2;
        swiperBannerConfig.centeredSlides = true;
        swiperBannerConfig.spaceBetween  = 12;
    } else {
        // Modalità fade su desktop
        swiperBannerConfig.effect         = 'fade';
        swiperBannerConfig.slidesPerView  = 1;
        swiperBannerConfig.centeredSlides = true;
    }

    var swiperBanner = new Swiper(".swiper-breaking", swiperBannerConfig);
}


    });
})(jQuery); 